import { Platform } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IonGrid, IonRow, IonCol, IonButton, IonFab, IonIcon, IonFabButton, IonText, IonContent, IonCard, IonLabel, IonRippleEffect, IonCardTitle } from '@ionic/angular/standalone';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-crisis-resource',
  templateUrl: 'crisis-resource.page.html',
  styleUrls: ['crisis-resource.page.scss'],
  standalone: true,
  imports: [
    IonLabel,
    IonCard,
    IonText,
    IonFabButton,
    IonIcon,
    IonFab,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    RouterModule,
    IonContent,
    IonRippleEffect,
    IonCardTitle,
    CommonModule
],
})
export class CrisisResourcePage {

  backSubscription?: Subscription;

  private readonly GOOGLE_STORE_LINK = 'https://play.google.com/store/apps/details?id=net.pssolutions.lighthouse';
  private readonly APPLE_STORE_LINK = 'https://apps.apple.com/us/app/columbia-protocol/id1450966911';

  buttons: { link: string; label: string }[] = [];

  constructor(
    private platform: Platform, 
    private appService: AppService, 
    private router: Router
  ) {}

  ionViewWillEnter(): void {
    this.backSubscription = this.appService.backSubject.subscribe(_ => {
      this.router.navigateByUrl('/home');
    });

    this.initializePlatformButtons();
  }

  ionViewWillLeave(): void {
    if (this.backSubscription) {
      this.backSubscription.unsubscribe();
    }
  }

  initializePlatformButtons() {
    this.buttons = [];

    if (this.platform.ANDROID) {
      this.buttons.push({ link: this.GOOGLE_STORE_LINK, label: 'Google Play Store' });
    } else if (this.platform.IOS) {
      this.buttons.push({ link: this.APPLE_STORE_LINK, label: 'Apple App Store' });
    } else {
      this.buttons = [
        { link: this.GOOGLE_STORE_LINK, label: 'Google Play Store' },
        { link: this.APPLE_STORE_LINK, label: 'Apple App Store' }
      ];
    }
  }
}
